module.exports = __webpack_public_path__ + "static/media/iconUser.19aa2f07.svg";